var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paper-detail"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.paperName)+" ")]),_c('div',{staticClass:"scroll-content"},[_c('el-scrollbar',{staticStyle:{"height":"100%"}},[_c('PaperPreview',{attrs:{"paperDetail":_vm.detailData}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }